import React from 'react';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import Divider from 'material-ui/Divider';
import _ from 'lodash';

// MaterialUI input components issue problems when using null as value
// So we have to emulate null for select as a string
const NULL = '_NULL_';

const clientLabelStyle = {
  padding: '0px 5px',
  marginLeft: '10px',
  float: 'right',
  boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)',
  fontStyle: 'italic',
  minWidth: '80px',
  color: 'black',
};
const menuItemStyle = {
  whiteSpace: 'normal',
};
const dividerStyle = {
  width: '100%',
  marginTop: '10px',
  marginBottom: '10px',
};

// TODO: find a better workaround for MaterialUI input components issue
const IntroMessagesDropdown = ({ introMessages = [], value, onChange, disabled }) => {
  introMessages = [{ id: NULL, text: '-' }, ...introMessages];
  const getSelectedMessage = (value) =>
    introMessages.find((msg) => _.get(msg, 'id') === value);
  value = +value || NULL;

  return (
    <SelectField
      id="intro-message-select"
      floatingLabelText="Intro Message"
      style={{ width: '100%' }}
      value={value}
      disabled={disabled}
      onChange={(event, key, value) => {
        event.target.name = 'introMessageId';
        event.target.value = value === NULL ? null : value;
        return onChange(event);
      }}
      selectionRenderer={(value) => _.get(getSelectedMessage(value), 'text')}
    >
      {introMessages.map(({ organization, text, id }) => (
        <MenuItem value={id} style={menuItemStyle} key={id}>
          <div>
            {organization && <div style={clientLabelStyle}>{organization.name}</div>}
            {text}
          </div>
          <Divider style={dividerStyle} />
        </MenuItem>
      ))}
    </SelectField>
  );
};

export default IntroMessagesDropdown;



// WEBPACK FOOTER //
// ./components/molecules/IntroMessagesDropdown/IntroMessagesDropdown.js